var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._t("default")],2),_vm._v(" "),_c('rating',{attrs:{"max":5,"disabled":_vm.disabled,"icon":_vm.icon,"defaultIndex":0},on:{"input":_vm.rateAction}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8fefb26","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/questions/QuestionRater.vue
// module id = 830
// module chunks = 0